import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';

// Components
import MainNav from 'components/common/MainNav';
import MenuMobile from 'components/common/MenuMobile';

class Header extends React.Component {
  constructor(props) {
    super(props);

    // Bindings
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.toggleMenu();
  }

  toggleScroll() {
    if (this.props.menuOpen) {
      // document.body.style.overflowY = 'hidden';
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
    } else {
      // document.body.style.overflowY = 'auto';
      document.getElementsByTagName('html')[0].style.overflowY = 'auto';
    }
  }

  render() {
    const className = classNames('l-header', {
      '-fixed': this.props.fixed,
      'no-print': this.props.fixed,
      [this.props.className]: this.props.className,
      '-home': !this.props.fixed && window.location.pathname === '/'
    });

    this.toggleScroll();

    return (
      <header className={className} ref="l-header">
        <div className="header-container">
          <div className="row align-middle c-header">
            <div className="column small-12 medium-2 large-2 icons-menu">
              <a className="logo align-logo-right" href="http://www.resourcegovernance.org/">
                <svg className="icon-logo">
                  <use xlinkHref="#icon-logo"></use>
                </svg>
              </a>
              <button className="menu-btn" onClick={this.onClick}>
                <svg className="c-icon icon-hamburger">
                  <use xlinkHref="#icon-menu"></use>
                </svg>
              </button>
            </div>
            <div className="column small-12 medium-9 print-title">
              <h2 className="title">2017 Resource Governance Index</h2>
            </div>
            <div className="column small-12 medium-7 large-7 main-nav no-print">
              <MainNav publicationsAndDataList={this.props.publicationsAndDataList} />
            </div>
            <div className="column medium-3 rgi-logo">
              <Link className="logo" to="/">
                <svg className="icon-logo --large">
                  <use xlinkHref="#rgi-icon-logo"></use>
                </svg>
              </Link>
            </div>
          </div>
        </div>
        <MenuMobile
          publicationsAndDataList={this.props.publicationsAndDataList}
          className={this.props.menuOpen ? '-active' : ''}
          toggleMenu={this.props.toggleMenu}
        />
      </header>
    );
  }
}

Header.propTypes = {
  fixed: PropTypes.bool,
  publicationsAndDataList: PropTypes.array,
  className: PropTypes.string,
  menuOpen: PropTypes.bool,
  // Actions
  toggleMenu: PropTypes.func
};

export default Header;



// WEBPACK FOOTER //
// ./app/components/common/Header.jsx